import React from 'react';
import { BTM_SITE_MAP_LEGEND_ITEMS } from '../../lib/btmStrategyMapLegend';

interface Props {
  className?: string;
  testId?: string;
}

/** Floating map legend — per-site BTM feasibility / risk tiers. */
export function BtmStrategyMapLegend({
  className = '',
  testId = 'btm-strategy-map-legend',
}: Props): React.ReactElement {
  return (
    <div
      data-testid={testId}
      className={`p-3 bg-background/90 border border-border backdrop-blur-sm space-y-2 ${className}`}
    >
      <p className="type-meta uppercase tracking-widest text-text-muted">Per-site BTM verdict</p>
      {BTM_SITE_MAP_LEGEND_ITEMS.map(({ label, dotClass }) => (
        <div key={label} className="flex items-center gap-2">
          <div className={`w-2 h-2 rounded-full shrink-0 ${dotClass}`} aria-hidden="true" />
          <span className="type-meta uppercase tracking-widest text-text-primary">{label}</span>
        </div>
      ))}
    </div>
  );
}
